// Darcy's guest-menu photography, keyed by stable menu item ID.
//
// Two rules govern this file, and both exist because a menu photo is a
// representation of the dish a guest is about to pay for:
//
//   1. A photo only ships if it genuinely shows THAT dish. No "close enough".
//      A wrong photo is worse than no photo — the DishPlaceholder SVG in
//      GuestMenu renders for any item missing here, and it looks clean.
//   2. Photos are self-hosted from /public/menu-photos, never hotlinked.
//      Hotlinking Wikimedia rate-limited (HTTP 429) as soon as several
//      images loaded at once, which is the normal case on a hotel network
//      where every guest shares one public IP.
//
// Sources: Pexels (free licence, commercial use, no attribution required)
// and Wikimedia Commons CC0. Every file was reviewed against its dish name.
//
// Items intentionally absent fall back to the placeholder — see REDSPEED.md
// §10. Restaurant-uploaded images always win over this map (see menuApi.js),
// so Darcy's own photography replaces these with no code change.

const photo = (id) => `/menu-photos/${id}.jpg`;

const WITH_PHOTOS = [
  'ent-01', // Spring Rolls
  'ent-02', // Arancini Balls with Relish
  'ent-03', // Cheesy Garlic Bread
  'ent-04', // Salt & Pepper Calamari with Salad (Commons, CC0)
  'ent-05', // Ginger Prawn Dumplings
  'ent-06', // Vegetable Dumplings
  'ent-09', // Loaded Fries - Pulled Pork, BBQ Sauce, Garlic Aioli & Cheese
  'kid-01', // Fish & Chips
  'kid-02', // Schnitzel & Chips
  'wrp-01', // Sweet Chilli Chicken Wrap
  'ind-04', // Tandoori Chicken (Full)
  'bgp-01', // Grampians Beef Burger
  'bgp-03', // Chicken Schnitzel Burger
  'bgp-04', // Grilled Chicken Burger
  'hal-01', // Beef Burger with Chips
  'des-01', // Soft Pancakes with Ice Cream
];

export const MENU_IMAGES = Object.fromEntries(
  WITH_PHOTOS.map((id) => [id, photo(id)]),
);
